export interface Location {
  id?: number;
  name: string;
  description?: string;
  latitude?: number | null;
  longitude?: number | null;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
}

export interface LocationFilters {
  id?: number | null;
  name?: string | '';
  is_active?: boolean | '';
  page: number;
  per_page: number;
  sort: string;
  order: string;
}

export const defaultLocationFilters: LocationFilters = {
  page: 1,
  per_page: 10,
  sort: 'id',
  order: 'asc'
};
